import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { modalState } from '@/state/modal.state';
import { Modal } from '@/ui/modal/modal';

import { DealRadio } from '../projects/project-listings/stage-management-table/deal-radio/deal-radio';
import { useUpdateProjectListingStage } from '../projects/project-listings/use-update-project-listing-stage.mutation';
import { useAtom } from 'jotai';

export const DealModal = () => {
  const { t } = useTranslation('projects');
  const [modal, setModalState] = useAtom(modalState);
  const [selectedDealType, setSelectedDealType] = useState<string | null>(null);
  const { editProjectListingStage: changeProjectListingStatus } =
    useUpdateProjectListingStage();

  if (modal?.state !== 'deal') return null;

  const close = () => {
    if (modal.onClosed) modal.onClosed();
    setModalState(null);
  };

  const handleStatusChange = () => {
    if (!selectedDealType) return;

    void changeProjectListingStatus({
      newProjectListingStageId: selectedDealType,
      projectListingId: modal.listingId,
    });

    modal.onSuccess?.(selectedDealType);
    close();
  };

  return (
    <Modal
      data-testid="project-listing-status-deal-modal"
      header={t`projectOverview.deal`}
      onClose={close}
      mainAction={{
        label: t`Done`,
        onClick: handleStatusChange,
      }}
      secondaryAction={{
        label: t`Cancel`,
        onClick: close,
      }}
      disabled={!selectedDealType}
      variant="info"
    >
      <Content>
        <Description>{t`listings.whatKindOfDeal`}</Description>
        <DealRadio value={selectedDealType} onSelect={setSelectedDealType} />
      </Content>
    </Modal>
  );
};

const Content = styled('div')`
  padding: 0 0 90px 0;
`;

const Description = styled('p')`
  ${({ theme }) => theme.typography.acrossPlatform.small};
  color: ${({ theme }) => theme.colors.gray.c12};
  margin-bottom: 36px;
`;
